window.SplashScreen = SiTextColumn.extend({

    render: function() {
		var content = this.getContent(this.data);
		this.$el.html(content);

		this.$backgroundManager = this.$el.closest("#wrapper").find(".background-image-container");
		this.$backgroundManager.addClass("splash-background");

		this.buildInAnimation();
		this.addListener();
		this.complete();
    },

    buildInAnimation: function() {
        this.$logos = this.$el.find(".logos");
        this.$textWrapper = this.$el.find(".text-wrapper");
        TweenMax.staggerFrom([this.$logos, this.$textWrapper], 0.3, {
            y: 5,
            opacity: 0,
            ease: Power4.easeOut,
            delay: 0.5
        }, 0.1);
    },

    addListener: function() {
        this.$("a").each(function() {
            new Button({
                el: this,
                buttonClass: "action-button"
            });
        });
    },

    getContent: function(data) {
        return Handlebars.templates["splash/splashscreen"](data);
    },

    getData: function($xml, language) {
        var data = SiTextColumn.prototype.getData.call(this, $xml, language);
        data.enter = LanguageManager.getString("enter");

        var blockTitle = this.blockData.title();
        _.each(data.items, function(item, i) {
            item.blockTitle = blockTitle;

            var images = item.image.split("|");

            if(!_.isEmpty(String(images[0]).trim()) ) item.image_1 = String(images[0]).trim();
            if(!_.isEmpty(String(images[1]).trim()) ) item.image_2 = String(images[1]).trim();
            
        }, this);

        data.projectTitle = LanguageManager.getString("project_title");
        data.unionlearn = LanguageManager.getString("unionlearn");
        
        return data;
    },

    destroy: function() {
        if (this.$backgroundManager.hasClass("splash-background")) this.$backgroundManager.removeClass("splash-background");
        SiTextColumn.prototype.destroy.call(this);
    }
});
